import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { ReactComponent as EditIcon } from "../../../assets/svg/editIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svg/delete.svg";
import { ReactComponent as PreviewIcon } from "../../../assets/svg/eye_icon.svg";
import { FunctionUninstall } from "./functionImport/FunctionUninstall";
import { DeleteFunctionModal } from "./DeleteFunctionModal";



export const FunctionCardTooltip = (props: any) => {
  const { functionData,
    deleteproduct,
    install,
    setTooltipVisible,
    handleFunctionStatus,
    editAccess } = props;
  const history = useHistory();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const handleClick = (): void => {
    history.push(`/marketplace/functions/functionPreview/${functionData.id}`)
  }

  const handleEdit = (e: any) => {
    e.stopPropagation()
    history.push(`/marketplace/functions/edit/${functionData.id}`)
  }
  const handleUnInstall = () => {
    setTooltipVisible(false);
    setDeleteModalVisible(true);
  };

  const handleDelete = () => {
    setTooltipVisible(false);
    setDeleteModalVisible(true);
  }

  const WIDTH = "16px";
  const HEIGHT = "16px";

  return (
    <div className="widget-card-tooltip">
      <div data-test-id="eye_icon" className="option" onClick={handleClick}>
        <PreviewIcon  style={{ marginTop: "5px" }}/>
        <span style={{ color: "#292d32" }}>Preview</span>
      </div>
      {editAccess ?
        <div className="option" onClick={handleEdit}>
          <EditIcon data-test-id="edit_icon" width={WIDTH} height={HEIGHT} />
          <span style={{ color: "#292d32" }}>Edit</span>
        </div> : null}
      {install ?
        <>
          <div className="option" onClick={handleUnInstall}>
            <DeleteIcon data-test-id="delete_icon" width={WIDTH} height={HEIGHT} />
            <span style={{ color: "#292d32" }}>Uninstall</span>
          </div>
          <FunctionUninstall
            visible={deleteModalVisible}
            setVisible={setDeleteModalVisible}
            handleFunctionStatus={handleFunctionStatus}
            functionData={functionData}
          />
        </>
        :
        <>
          {editAccess ?
            <div>
              <div className="option" onClick={handleDelete}>
                <DeleteIcon width={WIDTH} height={HEIGHT} />
                <span>Delete</span>
              </div>
              <DeleteFunctionModal
                data-test-id="delete_widget_modal"
                visible={deleteModalVisible}
                setVisible={setDeleteModalVisible}
                {...functionData}
                deleteproduct={deleteproduct} />
            </div>
            : null}
        </>
      }
    </div>
  );
};